define('home/views/ActivityCardCreateView',[
    'underscore',
    'backbone-marionette',
    'home/mixins/withReasonOld',
    'home/mixins/withSubviews',

    'home/views/ActivityFooterCreateView',
    'home/views/PostCollectionView',

    'home/templates/activityCardCreate',
], function (
    _,
    Marionette,
    withReason,
    withSubviews,

    ActivityFooterCreateView,
    PostCollectionView,

    activityCardCreateTemplate
) {
    'use strict';

    var parent = Marionette.ItemView;


    var ActivityCardCreateView = parent.extend({
        template: activityCardCreateTemplate,
        templateHelpers: function () {
            var forumFavicon = this.model.thread.forum.get('favicon') &&
                this.model.thread.forum.get('favicon').cache;

            return {
                target: this.model.activities[0].target.toJSON(),
                discussionRoute: this.model.thread.getDiscussionRoute(),
                threadDescriptionHTML: this.model.thread.getDefaultDescription(),
                recentPostCount: this.model.thread.recentPosts.length,
                shouldCollapse: this.shouldCollapse(),

                // Hide default favicons
                hideForumFavicon: !forumFavicon || /favicon-default/.test(forumFavicon),
            };
        },

        initialize: function () {
            this.listenTo(this.model.thread, 'change:content', this.render);
        },

        regions: {
            postsRegion: '[data-role=posts]',
            footerRegion: '[data-role=footer]',
        },

        onRender: function () {
            this.activateRegion(this.postsRegion, this.createPostsView);
            this.activateRegion(this.footerRegion, this.createFooterView);
        },

        createPostsView: function () {
            return new PostCollectionView({
                el: this.postsRegion.el,

                collection: this.model.thread.recentPosts,

                itemViewOptions: function (activity, index) {
                    // Add 'collapsible' class to posts after the first one. Only the first
                    // post shows by default and the rest are collapsed.
                    var existingClassName = this.getItemView(activity).prototype.className;
                    existingClassName = _.isFunction(existingClassName) ?
                        existingClassName.call({ model: activity }) :
                        existingClassName || '';

                    var className = existingClassName;
                    if (index > 0)
                        className += ' collapsible';

                    return {
                        className: className,
                    };
                },
            });
        },

        createFooterView: function () {
            var footerView = new ActivityFooterCreateView({
                el: this.footerRegion.el,
                model: this.model,
            });

            // Propogate event up
            this.listenTo(footerView, 'toggle:collapsed', function () {
                this.trigger('toggle:collapsed');
            });

            return footerView;
        },

        // Card should collapse (and therefore contain an expand link) if there's
        // more than 1 post showing. Posts after the first post are collapsed
        // by default.
        shouldCollapse: function () {
            return this.model.thread.recentPosts.length > 1;
        },
    });


    var proto = ActivityCardCreateView.prototype;
    withReason.call(proto);
    withSubviews.call(proto);

    return ActivityCardCreateView;
});

